export enum ASSET_EVENTS_FILTERS {
  TYPE = "filter[type]",
  SUB_TYPE = "filter[sub_type]",
  OCCURRING_DATE_TIME = "filter[occurring_date_time]",
}
